/* eslint-disable jsx-a11y/anchor-is-valid */
import { default as classNames, default as cx } from 'classnames'
import React, { useEffect, useState } from 'react'
import { Accordion, Card, Col, Dropdown, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import emptyKnowledge from '../../../assets/New-images/empty-knowledge.svg'
import sortIcon from '../../../assets/New-images/sort-blue-icon.svg'
import { KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH } from '../../../config'
import '../../../routes/Knowledge/AllKnowledge/AllKnowledge.scss'
import {
  getAllKnowledge,
  getAllLevels,
  getAllModulesFromYear,
} from '../../../store/knowledge/actions'
import {
  isAllKnowledgeError,
  isAllKnowledgeLoading,
  isAllKnowledgeSuccess,
  isTopicsLoading,
} from '../../../store/knowledge/selector'
import { getAllUserGroupOptions } from '../../../store/notifications/actions'
import Pagination from '../Pagination/Pagination'

import { useTranslation } from 'react-i18next'

function KnowledgeSearchModalComponent(props: any) {
  const { t } = useTranslation('translation')
  const useLocatio = useLocation()
  const dispatch = useDispatch()
  const [perPage, setPerPage] = useState(30)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const allKnowledgeSuccess = useSelector(isAllKnowledgeSuccess)
  const allKnowledgeLoading = useSelector(isAllKnowledgeLoading)
  const topicsLoading = useSelector(isTopicsLoading)
  const allKnowledgeError = useSelector(isAllKnowledgeError)

  const [activeKey, setActiveKey] = useState(null)
  const [years, setYears] = useState([])
  const [selectedYear, setSelectedYear] = useState(null)
  const [modules, setModules] = useState([])
  const [selectedParentModule, setSelectedParentModule] = useState<any>()
  const [topicIds, setTopicIds] = useState('')
  const [selectedKnowledge, setSelectedKnowledge] = useState(null)

  useEffect(() => {
    if (!topicsLoading) {
      // dispatch(getAllTopics());
      // dispatch(getAllIntents());
      dispatch(getAllUserGroupOptions()) // user groups
    }
    setSelectedNodes([])
    setHasTopLevelApplied(false)
    getAllYearsFun()
  }, [])

  const isBranchUnderSelectedModule = (level: any) => {
    if (!selectedParentModule) {
      return false
    }

    const findParent = (module: any) => {
      const parent = modules.find(m => m._id === module.parent_id)
      return parent
    }

    let parent = findParent(level)

    while (parent) {
      if (parent._id === selectedParentModule._id) {
        return true
      }
      parent = findParent(parent)
    }
    return false
  }

  const getAllYearsFun = async (loadSubModules: boolean = true) => {
    try {
      const response: any = await dispatch(getAllLevels())
      setYears([...response])

      const query = new URLSearchParams(useLocatio.search)
      const parent = query.get('parent')
      if (parent) {
        const parentVal = response.find((par: any) => par._id === parent)
        if (parentVal) {
          getAllModulesFromYearFun(parentVal)
        } else {
          response &&
            response.length > 0 &&
            getAllModulesFromYearFun(selectedYear ? selectedYear : response[0])
        }
      } else {
        response &&
          response.length > 0 &&
          getAllModulesFromYearFun(selectedYear ? selectedYear : response[0])
      }
    } catch (error: any) {
      setYears([])
    }
  }

  const getAllModulesFromYearFun = async (year: any) => {
    setSelectedYear(year)
    try {
      const query = new URLSearchParams(useLocatio.search)
      const group = query.get('group')
      const response: any = await dispatch(getAllModulesFromYear(year._id))
      setModules([...response])
      if (group) {
        setSelectedGroupId(group)
      } else {
        if (response && response.length > 0) {
          onSelectGroupId(response[0].value)
          if (response[0].depth === 0) {
            setSelectedParentModule(response[0])
          }
        } else {
          onSelectGroupId(year._id)
        }
      }
    } catch (error: any) {
      setModules([])
    }
  }

  useEffect(() => {
    setTotalRows(allKnowledgeSuccess?.pagination?.total_items)
  }, [allKnowledgeSuccess])
  /**
   *
   * @param page Pagination on change of page
   */
  const handlePageChange = (page: number) => {
    // e.preventDefault();
    // console.log('[[[[[ DISPATCHED ]]]]]', currentPage, page)
    setCurrentPage(page)
    // console.log('in')
    dispatch(
      getAllKnowledge(
        3,
        page,
        perPage,
        query,
        topicIds,
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroupId,
        hasTopLevelApplied,
      ),
    )
  }
  /**
   * Used to paginate data based on per page and page number
   * @param newPerPage
   * @param page
   */
  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage)
    setCurrentPage(page)
    // console.log('in')
    dispatch(
      getAllKnowledge(
        3,
        page,
        newPerPage,
        query,
        topicIds,
        {},
        selectedNodes.length > 0,
        props.documentId,
        selectedGroupId,
        hasTopLevelApplied,
      ),
    )
  }

  /**
   * Set debounce time for while searching in any input
   */
  const [query, setQuery] = useState('')
  const [isTyping, setTyping] = useState(false)
  useEffect(() => {
    // Added 500 as debounce time will wait for 500 miliseconds and then we will fetch intents based on query
    const delayDebounceFn = setTimeout(() => {
      if (isTyping) {
        setCurrentPage(1)
        // console.log('in')
        dispatch(
          getAllKnowledge(
            3,
            1,
            perPage,
            query,
            topicIds,
            {},
            selectedNodes.length > 0,
            props.documentId,
            selectedGroupId ? selectedGroupId : null,
            query && query.length > 0 ? true : false,
          ),
        )
        setTyping(false)
      }
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [query])

  const onInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setQuery(e.target.value)
    setTyping(true)
  }
  /**
   * State to manage tags | categories as Nodes | Tags whatever we can say
   */
  const [selectedNodes, setSelectedNodes] = useState([])

  /**
   * Used to sort data using API
   * @param param0
   * @param direction
   */
  const onSortHandler = (selector: any, direction: string) => {
    // For now we are allowing server side sorting on above two fields
    // console.log('in')
    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        topicIds,
        {
          sort_field: selector === 'name' ? 'question' : selector,
          sort_order: direction === 'desc' ? 'dsc' : 'asc',
        },
        selectedNodes.length > 0,
        props.documentId,
        selectedGroupId,
        hasTopLevelApplied,
      ),
    )
  }

  /**
   * Used to sort data using API
   * @param param
   * @param direction
   */
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [hasTopLevelApplied, setHasTopLevelApplied] = useState(true)

  useEffect(() => {
    // if (allKnowledgeLoading) {
    //   return
    // }
    if (!selectedGroupId) {
      return
    }

    dispatch(
      getAllKnowledge(
        3,
        currentPage,
        perPage,
        query,
        '',
        {},
        selectedNodes.length > 0,
        props.documentId,
        !props.documentId ? selectedGroupId : null,
        hasTopLevelApplied,
      ),
    )
  }, [selectedGroupId])

  const onSelectGroupId = (level: string) => {
    // For now we are allowing server side sorting on above two fields
    setSelectedGroupId(level)
  }

  const knowledgeHtml = (
    <>
      <div className="all-knowledge-search d-flex flex-wrap align-items-center mb-2">
        <Dropdown className="mr-2 sort-dropdown">
          <Dropdown.Toggle
            className="btn btn-outline-primary font-600 py-1 my-1 "
            variant="default"
            id="dropdown-basic"
          >
            <img src={sortIcon} alt="" className="mr-2" />
            {t('Sort')}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('updated_at', 'desc')
              }}
            >
              {t('Most Recent')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'asc')
              }}
            >
              {t('Ascending')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'desc')
              }}
            >
              {t('Descending')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <div className="web-links my-0 mr-0">
          <input
            type="text"
            className="form-control h-auto"
            placeholder={t('Search for Questions')}
            onChange={onInputChangeHandler}
          />
        </div>
        <button
          className={classNames({
            'btn ml-auto font-600 radius-8': true,
            'btn-light': !selectedKnowledge,
            'btn-primary': selectedKnowledge,
          })}
          disabled={!selectedKnowledge}
          onClick={() => {
            props.knowledgeConfirmHandler(selectedKnowledge)
          }}
        >
          {t('Select Knowledge')}
        </button>
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center mt-1">
        <div className="d-flex align-items-center"></div>
      </div>
      <Accordion
        defaultActiveKey={
          allKnowledgeSuccess && allKnowledgeSuccess.intents.length > 0
            ? allKnowledgeSuccess.intents[0]._id
            : null
        }
        className="accordion-viewby mt-3 scroll-wrap"
      >
        {allKnowledgeSuccess &&
          allKnowledgeSuccess.intents &&
          allKnowledgeSuccess.intents.map((knowledge: any, index: number) => {
            return (
              <Card
                className={cx({
                  active:
                    activeKey === '0' || knowledge._id === selectedKnowledge,
                  notactive: activeKey !== '0',
                })}
                key={knowledge?._id}
                onClick={() => {
                  setSelectedKnowledge(knowledge._id)
                }}
              >
                <Card.Header>
                  <span
                    className={`${
                      knowledge.is_suggested ? 'is_suggested' : ''
                    }`}
                  >
                    {knowledge.questions && knowledge.questions.length > 0
                      ? knowledge.questions[knowledge.questions.length - 1].text
                      : ''}
                    <small className="d-block k-breadcrumb">
                      {knowledge.breadcrumbs &&
                        knowledge.breadcrumbs.length > 0 &&
                        knowledge.breadcrumbs.map((b: any) => b.name).join('/')}
                    </small>
                  </span>
                </Card.Header>
              </Card>
            )
          })}
      </Accordion>

      {/* empty state */}
      {allKnowledgeSuccess &&
        allKnowledgeSuccess.intents.length === 0 &&
        !props.manageDocument && (
          <div className="empty-knowledge text-center my-5">
            <h3 className="h6 clr-grey-txt7 mb-3">
              {t('You have yet to create knowledge')}
            </h3>
            <figure className="h-auto">
              <img src={emptyKnowledge} alt="" />
            </figure>
            <div className="clr-primary font-weight-bold">
              {/* Drop a document here <span className="clr-grey-txt7">or</span>{" "} <br /> */}
              <Link
                to={
                  KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH +
                  (!hasTopLevelApplied
                    ? `?group=${selectedGroupId}&parent=${
                        selectedYear ? selectedYear._id : ''
                      }`
                    : '')
                }
              >
                {t('Click here to get started')}
              </Link>
            </div>
          </div>
        )}

      {allKnowledgeSuccess &&
        allKnowledgeSuccess.pagination &&
        allKnowledgeSuccess.intents.length > 0 && (
          <Pagination
            currentPage={currentPage}
            pagination={allKnowledgeSuccess.pagination}
            paginationPerPage={perPage}
            pageChange={handlePerRowsChange}
            onChangePage={handlePageChange}
            style={{ position: 'relative' }}
          />
        )}
    </>
  )

  if (allKnowledgeLoading && !allKnowledgeError) {
    // return <Loading />;
  }

  return (
    <>
      <>
        <div>
          <div className="levels-row mb-4 d-flex align-items-center flex-wrap">
            <h2 className="mb-0 mr-3 font-1">{t('Level:')}</h2>
            {years.map((year: any) => {
              return (
                <button
                  className={classNames({
                    'btn btn-tabs ': true,
                    active: selectedYear && year._id === selectedYear._id,
                  })}
                  onClick={() => {
                    setHasTopLevelApplied(true)
                    getAllModulesFromYearFun(year)
                    setSelectedKnowledge(null)
                  }}
                >
                  {year?.name}
                </button>
              )
            })}
          </div>
          <Row className="mb-4 position-relative">
            {selectedYear && selectedYear.group_type !== 'system' && (
              <Col lg={3} md={4} className="knowledge-modules mb-4 mb-md-0">
                <div className="knowledge-box p-0 build-knowbox text-left d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-center px-3 py-2">
                    <h2 className="mb-0 font-1">{t('Modules')}</h2>
                  </div>
                  {modules.length > 0 && (
                    <div className="modules-list flex-grow-1 scroll-wrap">
                      <ul className="list-unstyled">
                        {modules.map((level: any) => {
                          return (
                            <li
                              onClick={() => {
                                if (level.depth === 0) {
                                  setSelectedParentModule(level)
                                  setSelectedKnowledge(null)
                                }
                              }}
                              key={
                                'child_padding_dev_' +
                                level.value +
                                '_' +
                                Math.floor(Math.random() * 9999)
                              }
                              style={{
                                paddingLeft: `${
                                  level.depth > 0 ? level.depth * 10 + 10 : 10
                                }px`,
                                display: `${
                                  isBranchUnderSelectedModule(level) ||
                                  level.depth === 0
                                    ? 'block'
                                    : 'none'
                                }`,
                              }}
                              className={classNames({
                                'clr-grey-txt': level.depth > 0,
                                active: selectedGroupId === level.value,
                              })}
                            >
                              <a
                                href="javascript:void(0);"
                                onClick={() => {
                                  setSelectedNodes([])
                                  setHasTopLevelApplied(false)
                                  onSelectGroupId(level.value)
                                }}
                                className={classNames({
                                  'clr-grey-txt': level.depth > 0,
                                })}
                              >
                                {level?.label}
                              </a>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </Col>
            )}

            <div
              className={classNames({
                'knowledge-viewby': true,
                'col-lg-9 col-md-8':
                  selectedYear && selectedYear.group_type !== 'system',
                'col-lg-12 col-md-12':
                  selectedYear && selectedYear.group_type === 'system',
              })}
            >
              <div className="knowledge-box px-3 py-2 build-knowbox text-left">
                {knowledgeHtml}
              </div>
            </div>
          </Row>
        </div>
      </>
    </>
  )
}

export default KnowledgeSearchModalComponent
